import "whatwg-fetch"; // polyfill for older browsers
import {
  getMobileAPIConfig,
  convertQueryObjToString,
} from "@utils/browser-helpers";
import { executeAPIRequest } from "@adapters/api";
import { handleAPIResponse } from "@utils/browser-helpers";
const grpidRoute = "rpid_and_grpid_lookup",
  browseRoute = "browse";
export const grpidValidator = async (product) => {
  let query = { id: product };
  const apiConfig = getMobileAPIConfig(
    `${grpidRoute}${convertQueryObjToString(query)}`
  );
  try {
    const response = await executeAPIRequest(apiConfig, "GET", {
      Origin: apiConfig.url,
    });
    let responseData = await response.json();
    responseData = handleAPIResponse(responseData);
    let productInfo = responseData.grpid ? responseData.grpid : responseData;
    return productInfo;
  } catch (err) {
    console.warn("Error looking up product.", err);
    return err;
  }
};

export const fetchBrowseTree = async () => {
  const apiConfig = getMobileAPIConfig(browseRoute);
  try {
    const response = await executeAPIRequest(apiConfig, "GET", {
      Origin: apiConfig.url,
    });
    const responseData = await response.json();
    return handleAPIResponse(responseData);
  } catch (err) {
    console.warn("Error fetching browse tree.", err);
    return err;
  }
};
